import axios from 'axios';
import {req, reqJson} from './axiosFun';

/**
 * 酒店管理
 **/
// 酒店管理-获取用户列表
export const hotelList = (params) => { return reqJson("post", "/api/business/hotel/backendList?pageNum="+params.pageNum+"&pageSize="+params.pageSize, params) };
// 酒店管理-保存（添加）
export const hotelSave = (params) => { return reqJson("post", "/api/business/hotel/add", params) };
// 酒店管理-保存（编辑）
export const hotelEdit = (params) => { return reqJson("put", "/api/business/hotel/edit", params) };

export const hotelStatusEdit = (params) => { return reqJson("put", "/api/business/hotel/editHotelStatus", params) };

// 酒店管理-删除用户
export const hotelDelete = (params) => { return req("delete","/api/business/hotel/deleteById",params)};
// 酒店下拉列表
export const hotelSelect =(params) =>{ return reqJson("get","/api/business/hotel/selectList")}

//酒店关键字
export const DicGet = (params) => { return reqJson("get","/api/system/dictionary/queryByType?type="+params)};

//根据角色Id查询用户信息
export const hotelManger =(params) => { return reqJson("get","/api/system/user/getByRoleId?roleId="+params)};





// WEBPACK FOOTER //
// ./src/api/hotelMg.js